import { numericFormatter } from "react-number-format";
import { columns } from "../../../../dtos/columns";
import { RespuestaDividendosVigentesPacDTO } from "../models/respuestaDividendosVigentesPacDto";

interface IProps {
  controlTabla: any;
}

export function useColumnsPac({ controlTabla }: IProps) {
  const COLUMNS: columns<RespuestaDividendosVigentesPacDTO>[] = [
    {
      name: "N° Operación",
      selector: (row: RespuestaDividendosVigentesPacDTO) => row.numeroOperacion?.toString() || 'Desconocido',
      sortable: true,
      sortField: "numeroOperacion",
      wrap: true,
      export: true,
    },
    {
      name: "N° Dividendo",
      selector: (row: RespuestaDividendosVigentesPacDTO) => row.numeroDividendo?.toString() || 'Desconocido',
      sortable: true,
      sortField: "numeroDividendo",
      wrap: true,
      export: true,
    },
    {
      name: "Fecha vencimiento",
      selector: (row: RespuestaDividendosVigentesPacDTO) => {
        const fecha = new Date(row.fechaVencimiento);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fechaVencimiento",
      wrap: true,
      export: true,
    },
    {
      name: "Fecha cobro",
      selector: (row: RespuestaDividendosVigentesPacDTO) => {
        const fecha = new Date(row.fechaCobro);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fechaCobro",
      wrap: true,
      export: true,
    },
    {
      name: "Llave",
      selector: (row: RespuestaDividendosVigentesPacDTO) => row.llave?.toString() || '',
      sortable: true,
      sortField: "llave",
      wrap: true,
      export: true,
    },
    {
      name: "Monto pesos",
      selector: (row: RespuestaDividendosVigentesPacDTO) => numericFormatter((Math.round(row.montoPesos * 100)/100).toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "CLP " }),
      sortable: true,
      sortField: "montoPesos",
      wrap: true,
      export: true,
    },
    {
      name: "Banco",
      selector: (row: RespuestaDividendosVigentesPacDTO) => row.banco?.toString() || '',
      sortable: true,
      sortField: "banco",
      wrap: true,
      export: true,
    },
    {
      name: "Tipo cuota",
      selector: (row: RespuestaDividendosVigentesPacDTO) => row.tipoCuota?.toString() || '',
      sortable: true,
      sortField: "tipoCuota",
      wrap: true,
      export: true,
    },
    {
      name: "Monto cuota",
      selector: (row: RespuestaDividendosVigentesPacDTO) => row.montoCuota?.toString() || '',
      sortable: true,
      sortField: "montoCuota",
      wrap: true,
      export: true,
    },
    {
      name: "Día de descuento",
      selector: (row: RespuestaDividendosVigentesPacDTO) => row.diaDescuento?.toString() || '',
      sortable: true,
      sortField: "diaDescuento",
      wrap: true,
      export: true,
    },
  ]

  return { COLUMNS };
}
